// React
import type { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Custom types
import AuthGuardProps from 'src/types/props/authGaurdProps';

// Hooks and utils
import { useState } from 'react';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import logger from 'src/logging/logger';
import { getVerboseLogMsg } from 'src/utils/loggingUtils';

const AuthGuard: FC<AuthGuardProps> = (props) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);
  const { login } = useAuth() as any;
  const componentName = 'AuthGuard';

  if (!auth.isAuthenticated) {
    logger.verbose(getVerboseLogMsg(componentName, 'free form in component', 'user is not authenticated'));
    if (location.pathname !== requestedLocation) {
      logger.verbose(getVerboseLogMsg(componentName, 'free form in component', 'setting location.pathname:'), location.pathname);
      setRequestedLocation(location.pathname);
    }
    logger.verbose(getVerboseLogMsg(componentName, 'free form in component', 'logging in'));
    login();
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    logger.verbose(getVerboseLogMsg(componentName, 'free form in component', 'setting requested location to null and going to location: '), requestedLocation);
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
